import { render, staticRenderFns } from "./MinhasMatriculasDataTable.vue?vue&type=template&id=6693a041&scoped=true&"
import script from "./MinhasMatriculasDataTable.vue?vue&type=script&lang=js&"
export * from "./MinhasMatriculasDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MinhasMatriculasDataTable.vue?vue&type=style&index=0&id=6693a041&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6693a041",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemActionText } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VList,VListItem,VListItemAction,VListItemActionText,VListItemContent,VListItemTitle})
